import { FOfferType } from '../../utils/category';

type TOfferTypeLabel = {
  [key: number]: string;
};

// Локали для типов недвижимости. Аналогичный объект в offer_type/index
// не используется, так как в нем есть сокращения и все типы написаны с
// большой буквы.
export const offerTypeLabel: TOfferTypeLabel = {
  [FOfferType.AutoService]: 'автосервис',
  [FOfferType.Bed]: 'койко-место',
  [FOfferType.Building]: 'здание',
  [FOfferType.Land]: 'участок',
  [FOfferType.CommercialLand]: 'коммерческую землю',
  [FOfferType.DomesticServices]: 'бытовые услуги',
  [FOfferType.Flat]: 'квартиру',
  [FOfferType.FlatNew]: 'квартиру в новостройке',
  [FOfferType.FlatOld]: 'квартиру во вторичке',
  [FOfferType.FreeAppointmentObject]: 'ПСН',
  [FOfferType.Garage]: 'гараж',
  [FOfferType.House]: 'дом',
  [FOfferType.HousePart]: 'часть дома',
  [FOfferType.Manufacture]: 'производство',
  [FOfferType.Office]: 'офис',
  [FOfferType.FlatShared]: 'долю',
  [FOfferType.PublicCatering]: 'общепит',
  [FOfferType.Business]: 'готовый бизнес',
  [FOfferType.Room]: 'комнату',
  [FOfferType.Warehouse]: 'склад',
  [FOfferType.Townhouse]: 'таунхаус',
  [FOfferType.TradeArea]: 'торговую площадь',
};
